
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators",
      function () {
        return require("private-next-pages/creators/index.tsx");
      }
    ]);
  